export default {
  meta: {
    title: '拓店任务统计报表', // 拓店任务-标准版
  },
};
